import { AfterViewInit, ChangeDetectorRef, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { SuccessModalComponent } from '../success-modal/success-modal.component';
import {
  IMG_EXTENSIONS,
  INVALID_PARKING_LAYOUT_FORMAT,
  MSG_UPDATE_PARKING,
  SPOT_TYPE_LABEL,
  USER_ROLES,
  VALID_PARKING_LAYOUT_EXTENSIONS
} from '@shared/constant/shared.constant';
import { ParkingService } from '../services/parking.service';
import { ParkingLotSlotsResponse } from '@core/models/parking-slot.model';
import { ToastService } from '@shared/services/toast.service';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { validateInput, CustomValidator } from '@shared/services/custom-validatior.abstract';
import { EditParkingRequest, ParkingLotFacilityInput, ParkingLotImagesInput, ParkingLotSlotsInput, TruckTypeInput } from '@core/models/edit-parking-request.model';
import { BreadcrumbItem, CompanyService } from '@shared/services/company.service';
import { CommonFunctions } from '@shared/common-functions';
import { autoUnsubWith } from '@shared/services/utility.abstract';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';

@Component({
  selector: 'app-edit-parking-slot',
  templateUrl: './edit-parking-slot.component.html',
  styleUrls: ['./edit-parking-slot.component.scss']
})
export class EditParkingSlotComponent implements OnInit, AfterViewInit {
  readonly destroyRef = inject(DestroyRef);
  spotTypeMsg: string = SPOT_TYPE_LABEL;
  parkingPageData: any;
  truckTypes: any[] = [];
  parkingSlotForm!: FormGroup;
  isParkingLayoutError: boolean = false
  planDoc: string = ''
  isParkingLotLayoutDoc: boolean | null = null;
  imageLink: string = ''
  upldBtn: boolean = true
  delIcon: boolean = false
  formData: FormData = new FormData();
  isProfileImgError: boolean = false;
  pdfUrl: string = '';
  parkingLotId: string = "";
  parkingLotSlotsOutput: any = [];
  uploadenable: boolean = false;
  uploadenable1: boolean = false;
  isParkAnywhere: boolean;
  selectedTab: string;
  roleName : string;
  companyId: string;
  selectedSlotsMian: any[] = [];
  Threshold: any = `The "Threshold value" refers to a predefined level of parking lot occupancy and Trucklots notifies you when parking lot occupancy reaches the mentioned Threshold value.`;
  check: any;
  userRoles = USER_ROLES;
  constructor(
    private readonly fb: FormBuilder,
    private readonly activatedRoute: ActivatedRoute,
    private readonly dialogControlService: DialogControlService,
    private readonly parkingService: ParkingService,
    private readonly companyService: CompanyService,
    private readonly cdr: ChangeDetectorRef,
    private readonly toastService: ToastService,
    private readonly encryptStorage: EncryptionStorageService
  ) {

  }
  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }
  ngOnInit(): void {
    this.roleName = this.encryptStorage.getItem('roleName');
    this.companyId = this.encryptStorage.getItem('companyId');
    
    const localTruckTypes = this.getDataFromStorage('truckData') || [];
    this.truckTypes = localTruckTypes[0];
    const breadcrumbObj: BreadcrumbItem[] = [
      {
        title: 'Parking Locations',
        url: `${CommonFunctions.routeToBookingDetail(this.roleName)}/parking-list/${this.companyId}`
      },
      {
        title: 'Edit Parking'
      }
    ];
    this.companyService.setAdminHeaders('0', breadcrumbObj);
    this.buildForm();
    this.getParkingLotId();
    this.parkingPageData = this.getDataFromStorage('parkingFirstPage');
    this.selectedSlotsMian = this.getDataFromStorage('selectedSlotsMian');
    this.isParkingLotLayoutDoc = this.parkingPageData.isParkingLotLayoutDoc;
    this.check = this.getDataFromStorage('comingSoon')
    if (this.isParkingLotLayoutDoc) {
      this.planDoc = this.parkingPageData.parkingLayoutImg;
      this.pdfUrl = this.parkingPageData.parkingLayoutImg;
    }
    else {
      this.imageLink = this.parkingPageData.parkingLayoutImg;
    }

    if (this.imageLink || this.pdfUrl) {
      this.uploadenable = true;
      this.upldBtn = false
      this.delIcon = true
    }
    if (this.parkingPageData.isParkAnywhere == true) {
      this.selectedTab = 'parkAnywhere'
      this.isParkAnywhere = true

    }
    else {
      this.selectedTab = 'defineSlots'
    }
  }

  newTruckTypeEdit(_slots: any[]) {
    let matchedTruckTypes: any[] = [];
    this.truckTypes.forEach((truckType: any) => {
      this.cdr.detach();
      let selectedSlot = _slots.find((_slot: any) => _slot.vehicleTypeId === truckType.vehicleTypeId);

      if (selectedSlot) {
        matchedTruckTypes.push(selectedSlot);
      }
    });
    // Now `matchedTruckTypes` array contains the matched items
    if(matchedTruckTypes){
   this.bindData(matchedTruckTypes)
    }
    else{
      this.bindData(this.truckTypes)
    }
  }

  updateTotalSlotsValidatorForAllTruckTypes(): void {
    const truckTypeControls = this.parkingSlotForm.get('truckTypeArray') as FormArray;
    for (let i = 0; i < truckTypeControls.length; i++) {
      const totalSlotsControl = truckTypeControls.at(i).get('totalSlots');

      this.selectedTab === 'parkAnywhere' ? totalSlotsControl.clearValidators() : totalSlotsControl.setValidators(Validators.required)
      totalSlotsControl?.updateValueAndValidity();
    }
  }
  getParkingLotId(): void {
    this.activatedRoute.params.subscribe((params) => {
      this.parkingLotId = params['id'];
      this.getParkingLotDetailsWithSlots();
    })
  }
  getParkingLotDetailsWithSlots() {
    this.parkingService.getParkingLotDetailsWithSlots(this.parkingLotId)
      .pipe(
        autoUnsubWith(this.destroyRef)
      )
      .subscribe({
        next: (data: ParkingLotSlotsResponse) => {
          this.parkingLotSlotsOutput = data.parkingLotSlotsOutput;

          this.newTruckTypeEdit(this.parkingLotSlotsOutput)
          
        }
        , error: () => {
          
          this.newTruckTypeEdit(this.parkingLotSlotsOutput)
        }
      })
  }

  buildForm(): void {
    this.parkingSlotForm = this.fb.group({
      totalSlots: ['', [Validators.required, CustomValidator.validateGreaterThanZero, CustomValidator.validateLessThanThousand]],
      thresholdValue: ['', [Validators.required, CustomValidator.validateGreaterThanZero, CustomValidator.validateLessThanHundred]],
      truckTypeArray: this.fb.array([])
    });

  }

  bindData(slotData: any) {
    this.parkingSlotForm.patchValue({
      totalSlots: this.parkingPageData.totalSlots,
      thresholdValue: this.parkingPageData.thresholdValue
      // parkingLayoutImg :this.parkingPageData.parkingLayoutImg
    });

    this.truckTypes.forEach((truckType: any) => {
      this.cdr.detach();
      let selectedSlot = slotData.find((slot: any) => slot.vehicleTypeId === truckType.vehicleTypeId);

      if (selectedSlot) {
        this.truckTypeArray.push(this.addNewTruck(selectedSlot));
      } else {
        this.truckTypeArray.push(this.addEmptyNewTruck(truckType));
      }

      this.cdr.detectChanges();
    });

    this.cdr.reattach();
  }

  addNewTruck(truck: any): FormGroup {
    return this.fb.group({
      id: [truck.vehicleTypeId, [Validators.required]],
      truckName: [truck.vehicleName],
      totalSlots: [truck.slots.length, [Validators.required, CustomValidator.validateLessThanThousand]],
      parkingSlots: this.fb.array([...this.bindSlots(truck.slots)])
    }) as FormGroup;
  }

  addEmptyNewTruck(truck: any): FormGroup {
    return this.fb.group({
      id: [truck.vehicleTypeId, [Validators.required]],
      truckName: [truck.vehicleName],
      totalSlots: ['', [Validators.required, CustomValidator.validateLessThanThousand]],
      parkingSlots: this.fb.array([])
    }) as FormGroup;
  }
  private bindSlots(slots: any): FormGroup[] {
    const arr: FormGroup[] = [];
    slots.forEach((slot: any) => {
      arr.push(this.addNewParkingSlot(slot.slotName));
    })
    return arr;
  }

  get truckTypeArray(): FormArray {
    return this.parkingSlotForm.get("truckTypeArray") as FormArray
  }

  parkingSlotArray(slotIndex: number): FormArray {
    return this.truckTypeArray.at(slotIndex).get("parkingSlots") as FormArray
  }

  addNewParkingSlot(name: string) {
    return this.fb.group({
      slotName: [name, [Validators.required]],
    })
  }

  getDataFromStorage(key: string) {
    return JSON.parse(this.encryptStorage.getItem(key) ?? "")
  }
  slotChange(truckForm: any): void {
    let total = truckForm.get('totalSlots').value;
    let slots = truckForm.get('parkingSlots') as FormArray;
    this.clearFormArray(slots);

    const startChar = "A";
    if (truckForm.get('totalSlots').value < 1000) {
      for (let startVal = 1; startVal <= total; startVal += 1) {
        const slotVal = startVal < 10 ? `0${startVal}` : startVal;
        slots.push(this.addNewParkingSlot(`${startChar}${slotVal}`));
      }
    }
  }

  clearFormArray(formArray: FormArray): void {
    while (formArray.length !== 0) {
      formArray.removeAt(0)
    }
  }
  editParking(): void {
    if (this.selectedTab == 'parkAnywhere') {
      this.updateTotalSlotsValidatorForAllTruckTypes()
    }
    for (let i = this.truckTypeArray.value.length - 1; i >= 0; i--) {
      if (this.truckTypeArray.value[i].id == null) {
        // Remove the element from the array
        this.truckTypeArray.value.splice(i, 1);
      }
    }

    if (this.parkingSlotForm.valid) {
      let recurringInstruction = this.parkingPageData?.recurringInstructions !== null ?CommonFunctions.htmlEncode(this.parkingPageData?.recurringInstructions?.replace(/<img[^>]*>/g, '')): '';
      let editParkingRequest: EditParkingRequest = {
        id: this.parkingLotId,
        name: this.parkingPageData.name,
        hazardousLoadRate: +this.parkingPageData.hazardousLoadRate,
        isHazardousLoad: this.parkingPageData.isHazardousLoad,
        termsAndCondition: CommonFunctions.htmlEncode(this.parkingPageData.oneTimeInstructions?.replace(/<img[^>]*>/g, '')),
        offer: +this.parkingPageData.offer,
        parkingLotLayout: this.isParkingLotLayoutDoc ? this.planDoc : this.imageLink,
        isParkingLotLayoutDoc: this.isParkingLotLayoutDoc,
        totalNumberOfSlots: this.parkingSlotForm.get('totalSlots')?.value,
        thresholdValue: this.parkingSlotForm.get('thresholdValue')?.value,
        taxAndFees: +this.parkingPageData.taxAndFees,
        location: this.parkingPageData.location,
        // truckType: this.truckTypeArray.value,
        truckType: this.getSelectedTruckTypes(),
        parkingLotFacility: this.getSelectedFacilities(),
        parkingLotImages: this.getSelectedParkingImages(),
        editParkingLotSlotsInput: this.getSelectedParkingLotSlots(),
        parkingLotMaintenanceStartDate: (this.parkingPageData.startDate),
        parkingLotMaintenanceEndDate: (this.parkingPageData.endDate),
        isEntireParkingUnderMaintenance: this.parkingPageData.isEntireParkingUnderMaintenance,
        underMaintenanceNames: this.selectedSlotsMian,
        isParkAnywhere: this.isParkAnywhere,
        spaceUnderMaintenance: (!this.parkingPageData.spaceUnderMaintenance || this.parkingPageData.spaceUnderMaintenance === '') ? 0 : this.parkingPageData.spaceUnderMaintenance,
        isComingSoon: false,
        EditParkingLotSpotTypeSpecialRateInput: this.parkingPageData.specialRates  || [],
        termsAndConditionRecurring: recurringInstruction !== 'undefined' ? recurringInstruction : '',
        termsAndConditionFilePath: this.parkingPageData.termsAndConditionFilePath,
        accessCode: this.parkingPageData.oneTimeAccessCode,
        monthlyAccessCode: this.parkingPageData.monthlyAccessCode
      }
      let valid = true;
      if (this.selectedTab == 'defineSlots') {
        const idCountMap = new Map<string, number>(); // Map to store counts for each id
        // Count occurrences of each id
        editParkingRequest.editParkingLotSlotsInput.forEach((truck: any) => {
          const id = truck.vehicleTypeId;
          idCountMap.set(id, (idCountMap.get(id) || 0) + 1);
        });
        // Check if any id count exceeds the totalNumberOfSlots
        for (const truck of editParkingRequest.truckType
        ) {
          const id = truck.vehicleTypeId;
          const name = truck.vehicleName;
          const count = idCountMap.get(id) || 0;
          if (count > editParkingRequest.totalNumberOfSlots) {
            this.toastService.showToastMessage('error', 'Error', `Number of spots for '${name}' cannot be more than total number of spots`);
            return; // Stop processing if an error is found
          }
        }
      }
      if (valid) {
        this.parkingService.editParkingLot(editParkingRequest)
        .pipe(autoUnsubWith(this.destroyRef))
        .subscribe({
          next: () => {
            localStorage.removeItem('truckData');
            localStorage.removeItem('parkingFirstPage');
            
            this.openSuccessModal();
          },
          error: (err: HttpErrorResponse) => {
            
            this.toastService.showToastMessage('error', 'Error', err.error.message);
          }
        })
      }
    }
    else {
      const allParkingSlots = this.parkingSlotForm.value.truckTypeArray.flatMap(truckType => truckType.parkingSlots);
      for (const slot of allParkingSlots) {
        if (slot.slotName.trim() === '') {
          this.toastService.showToastMessage('error', 'Error', 'Slot name cannot be blank.');
          break;
        }
      }
    }
    CustomValidator.markFormGroupTouched(this.parkingSlotForm);

  }

getSelectedTruckTypes(): TruckTypeInput[] {
    let type: any;
    type = (this.truckTypes);
    return type;
  }
  getSelectedFacilities(): ParkingLotFacilityInput[] {
    const type: ParkingLotFacilityInput[] = [];
    const parkingLotFacility: any[] = this.parkingPageData.parkingLotFacility;
    parkingLotFacility.forEach((facility) => {
      type.push({
        facilityId: facility
      })
    })
    return type;
  }
  getSelectedParkingImages(): ParkingLotImagesInput[] {
    const type: ParkingLotImagesInput[] = [];
    const parkingPhotoData: any[] = this.parkingPageData.parkingPhotos;

    parkingPhotoData.forEach((url) => {
      type.push({
        imagePath: url
      })
    })
    return type;
  }
  getSelectedParkingLotSlots(): ParkingLotSlotsInput[] {
    const type: ParkingLotSlotsInput[] = [];
    this.truckTypeArray.controls.forEach((truck, index) => {
      const slotArray = this.parkingSlotArray(index);
      slotArray.controls.forEach((slot) => {
        type.push({
          vehicleTypeId: truck.get("id")?.value,
          slotName: slot.get("slotName")?.value
        })
      });
    });
    return type;
  }
  openSuccessModal(): void {
    this.dialogControlService.openDialog(SuccessModalComponent, {
      width: '30%',
      data: {
        bodyText: MSG_UPDATE_PARKING
      }
    });
  }

  onUpload(files: any, fileUpload: any) {
    const img = files[0].name;
    const fileExtension = img.split('.').pop();
    const file = files[0];
    const maxSize = 25 * 1024 * 1024;
    if (!VALID_PARKING_LAYOUT_EXTENSIONS.includes(fileExtension.toLowerCase())) {
      fileUpload.clear();
      this.toastService.showToastMessage('error', 'Error', INVALID_PARKING_LAYOUT_FORMAT);
      return
    }
    else if (file.size > maxSize) {
      this.isProfileImgError = true;
      fileUpload.clear()
      return
    }
    
    this.isProfileImgError = false
    this.formData.append('Images', file);
    this.parkingService.imageUplaod(this.formData)
     .pipe(
        autoUnsubWith(this.destroyRef)
      )
      .subscribe({
        next: (response) => {
          const data = response;
          for (const key in data) {
            if (data.hasOwnProperty(key)) {
              const url = data[key];
              if (IMG_EXTENSIONS.includes(fileExtension.toLowerCase())) {
                this.imageLink = url;
                this.upldBtn = false;
                this.delIcon = true;
                this.isParkingLotLayoutDoc = false;
              }
              else {
                this.pdfUrl = url;
                this.planDoc = url
                this.upldBtn = false;
                this.delIcon = true;
                // File extension is not valid
                this.isParkingLotLayoutDoc = true;
              }
            }
          }
          
        }
      })
  }
  fileSizeValidator(maxSize: number) {
    return (control: AbstractControl) => {
      if (control.value) {
        const file = control.value as File; // Cast control.value to File
        if (file.size > maxSize * 1024 * 1024) { // Convert maxSize to bytes
          return {
            fileSizeExceedsLimit: true
          };
        }
      }
      return null;
    };
  }
  deleteDocument(): void {
    this.formData = new FormData();
    this.imageLink = '';
    this.pdfUrl = '';
    this.upldBtn = true;
    this.delIcon = false;
    this.planDoc = "";
  }
  getFullDateTime(date: Date, dateTime: Date): Date | null {
    if (date && dateTime) {
      const convertedDate = new Date(date);
      const convertedTime = new Date(dateTime);
      convertedDate.setHours(convertedTime.getHours());
      convertedDate.setMinutes(convertedTime.getMinutes());
      return convertedDate;
    }
    else {
      return null;
    }
  }

  onDrop(event: any, fileUpload: any) {
    event.preventDefault();
    const files = event.dataTransfer.files;
    this.onUpload(files, fileUpload);
  }

  onDragOver(event: any) {
    event.preventDefault();
  }

  onDragLeave(event: any) {
    event.preventDefault();
  }

  onKeyPress(event: KeyboardEvent): void {
    if (!validateInput(event)) {
      event.preventDefault();
    }
  }
}
